import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  DrawerBody,
  DrawerFooter,
  Alert,
  Typography
} from '@one-thd/sui-atomic-components';
import { useScrollToTopOnMount } from '../hooks/useScrollToTopOnMount';
import { GENERIC_ERROR } from '../shared/Constants';

const ErrorDrawer = ({ message = '', onClose }) => {
  const scrollAnchorRef = useScrollToTopOnMount();

  return (
    <>
      <DrawerBody ref={scrollAnchorRef}>
        <Alert status="error">
          <Typography>{message || GENERIC_ERROR}</Typography>
        </Alert>
      </DrawerBody>
      <DrawerFooter>
        <Button
          fullWidth
          variant="primary"
          onClick={onClose}
        >
          OK
        </Button>
      </DrawerFooter>
    </>
  );
};

ErrorDrawer.propTypes = {
  onClose: PropTypes.func.isRequired,
  message: PropTypes.string
};

ErrorDrawer.displayName = 'ErrorDrawer';

export { ErrorDrawer };